<template>
  <div class="router-file">
  <!-- 路径文件管理 -->
  <el-row :gutter="20">
  <el-col :span="8" class="shadow">
  <!-- 车辆列表部分 -->
  <div>
      <!-- 查找参数区 -->
      <div class="filter-container">
          <el-input placeholder="请输入机器人ID" v-model="listQueryCar.params.id" style="width: 360px" class="filter-item"></el-input>
          <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleFilterCar">
            搜索
          </el-button>
      </div>
      <!-- 数据列表区 -->
      <el-table
        :data="listDataCar"
        v-loading="listLoadingCar"
        border
        highlight-current-row
        style="width: 100%;align: center;">
        <el-table-column prop="index" label="序号" width="60px" align="center">
        </el-table-column>
        <el-table-column prop="id" label="机器人ID" align="center">
        </el-table-column>
        <el-table-column prop="operator" label="操作" align="center">
          <template v-slot:="{row,$index}">
            <el-button type="primary" size="mini" @click="handleShowFileList(row)">
              显示文件列表
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页栏 -->
      <pagination :total="totalCountsCar"
	   layout='sizes,prev, pager, next' 
        @pagination="handlePageChangeCar">
      </pagination>
  </div>
  </el-col>
  <!-- 文件列表部分 -->
  <el-col :span="8" class="shadow">
  <div>
      <!-- 展示车辆ID -->
      <div class="car-id">
          路径文件所属机器人ID:
          <el-input
            style="width: 310px"
            placeholder=""
            v-model="curCarId"
            :disabled="true">
          </el-input>
      </div>
      <!-- 文件上传区 -->
      <el-upload
        v-if="showFileUpload"
        :multiple="false"
        class="upload-demo"
        ref="upload"
        name="mfile"
        action="http://localhost:9098/file/localUpload"
        :headers="uploadHeaders"
        :data="uploadData"
        :before-upload="beforeUpload"
        :on-success="successUpload"
        :on-error="errorUpload"
        accept=".jpg,.png,.pgm,.pcd,.traj,.PGM,.PCD,.JPG,.PNG"
        :file-list="file_list"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary" icon="el-icon-paperclip">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传<i class="el-icon-upload el-icon--right"></i></el-button>
        <div slot="tip" class="el-upload__tip">上传路径文件</div>
      </el-upload>
      <!-- 数据列表区 -->
      <el-table
        :data="listDataFile"
        v-loading="listLoadingFile"
        border
        highlight-current-row
        style="width: 100%;align: center;">
        <el-table-column prop="index" label="序号" width="60px" align="center">
        </el-table-column>
        <el-table-column prop="fileName" label="文件名" align="center">
        </el-table-column>
        <el-table-column prop="operator" label="操作" align="center">
          <template v-slot:="{row,$index}">
			  <el-button-group>
			   <el-button type="primary" size="mini" @click="handleFilePreview(row)">
			     预览
			   </el-button>
			   <el-button type="success" size="mini" @click="handleFileDownload(row)">
			     下载
			   </el-button>
			   <el-button type="danger" size="mini" @click="handleFileDelete(row)">
			     删除
			   </el-button>
			  </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页栏 -->
      <!-- <pagination :total="totalCountsFile"
        @pagination="handlePageChangeFile">
      </pagination> -->
  </div>
  </el-col>
  <!-- 预览部分 -->
  <el-col :span="8" class="shadow">
      <div>
          图片预览:
          <br />
          <el-image
            style=""
            :src="url"
            fit="contain"></el-image>
      </div>
  </el-col>
  </el-row>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import {carList} from '@/api/car'
import {fileList} from '@/api/file'
import {filePreview} from '@/api/file'
import {localDown} from '@/api/file'
import {localDelete} from '@/api/file'

export default {
  name: 'RouterFile',
  components: {
    Pagination
  },
  data(){
      return{
        // 车辆列表部分
        listLoadingCar: true,
        listDataCar: [],
        totalCountsCar: 0,
        listQueryCar: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          params: {
            id: undefined
          },
          fuzzySearch: true
        },
        //文件上传
        file_list:[],
        uploadHeaders:{authorization:this.$store.state.user.authorization},
        uploadData:{
            command_id:32,
            flag:"2",
            carId:this.curCarId,
            
        },
        //文件列表部分
        curCarId:undefined,
        listLoadingFile: false,
        listDataFile:[],
        // totalCountsFile:0,
        // listQueryFile:{
          // pageIndex: 1,
          // pageSize: 10,
          // params: {
          //   id: undefined
          // },
          // fuzzySearch: true
        // },
        showFileUpload:false,
        //图片预览部分
        url:""
      }
  },
  methods: {
      /**
       * handleFilterCar 用于请求车辆数据
       */
    handleFilterCar() {
      this.listLoadingCar = true
      carList(this.listQueryCar, null).then(res => {
        let data = res.pageData
        this.totalCountsCar = data.totalCounts
        // 对后端数据进行解析
        this.listDataCar = data.datas.map((item,index) => {
          return {
            index: index+1,
            id: item.id,
          }
        })
        this.listLoadingCar = false
      })
    },
    /**
     * 处理小车列表翻页
     * @param {Object} data
     */
    handlePageChangeCar(data) {
      this.listQueryCar.pageIndex = data.page
      this.listQueryCar.pageSize = data.limit
      this.handleFilterCar()
    },
    /**
     * 选择一辆小车展示文件列表
     * @param {Object} row
     */
    handleShowFileList(row){
        this.curCarId=row.id
        this.url=""
        this.showFileUpload=true,
        this.handleFilterFile()
    },
    /**
     * 刷新文件列表
     */
    handleFilterFile() {
      this.listLoadingFile = true
      fileList("2",this.curCarId).then(res => {
        if(res.result==="1"){
          let data = res.fileLists
          // this.totalCountsFile = data.totalCounts
          // 对后端数据进行解析
          this.listDataFile = data.map((item,index) => {
            return {
              index: index+1,
              fileName: item,
            }
          })
        }else{
            this.$message.error(res.message)
        }
        this.listLoadingFile = false
      })
    },
    /**
     * 提交上传文件
     */
    submitUpload(){
        this.uploadData.carId=this.curCarId
        this.$refs.upload.submit();
    },
    /**
     * 上传前检查文件
     * @param {Object} file
     */
    beforeUpload(file){
        if(!/\.(jpg|png|pgm|pcd|traj|PGM|PCD|JPG|PNG)$/.test(file.name)){
            this.$message({
              type: 'info',
              message: '图片类型必须是.jpg,png,pgm,pcd,traj中的一种!'
            });
            return false
        }
		let reg = /[\u4e00-\u9fa5]/g;
		if(file.name.indexOf(" ")!=-1 || reg.test(file.name)){
			this.$message({
			  type: 'info',
			  message: '文件名不能包含中文和空格！'
			});
			return false
		}
		if(file.size==0){
			this.$message({
			  type: 'info',
			  message: '文件大小为0KB，请重新选择文件！'
			});
			return false
		}
        return true
    },
    /**
     * 上传成功
     * @param {Object} res
     * @param {Object} file
     * @param {Object} fileList
     */
    successUpload(res, file, fileList){
        if(res.result==="0"){
            this.$message({
                message: res.message,
                type: 'success'
            })
            this.handleFilterFile()
        }else{
            this.$message.error(res.message)
        }
    },
    /**
     * 上传发生错误
     * @param {Object} err
     * @param {Object} file
     * @param {Object} fileList
     */
    errorUpload(err, file, fileList){
        this.$message.error(err)
    },
    /**
     * 处理预览
     * @param {Object} row
     */
    handleFilePreview(row){
        // this.url='/api/file/filePreview?flag=1&carId='+this.curCarId+"&fileName="+row.fileName
        this.url=''
        filePreview("2",this.curCarId,row.fileName).then(res=>{
            this.url=window.URL.createObjectURL(new Blob([res]))
        })
    },
    /**
     * 处理文件下载
     * @param {Object} row
     */
    handleFileDownload(row){
        localDown("2",this.curCarId,row.fileName)
        .then(res=>{
            this.download(res,row.fileName)
        })
    },
    // 下载文件
    download (data,fileName) {
        if (!data) {
            return
        }
        let url = window.URL.createObjectURL(new Blob([data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)

        document.body.appendChild(link)
        link.click()
        // window.URL.removeObjectURL(link.href)
        document.body.removeChild(link)
    },
    //删除文件
    handleFileDelete(row){
        if(this.listDataFile.length<=1){
            this.$message({
              type: 'info',
              message: '删除失败，必须保留一个文件!'
            });
        }else{
			this.$confirm('确定要删除吗？', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'	
			}).then(() => {
				localDelete("2",this.curCarId,row.fileName).then(res=>{
				    if(res.result==="0"){
				        this.$message({
				            message: res.message,
				            type: 'success'
				        })
				        this.handleFilterFile()
				    }else{
				        this.$message.error(res.message)
				    }
				})
			} ).catch(e=>e)
           
        }
    },
    // handlePageChangeFile(data) {
    //   this.listQuery.pageIndex = data.page
    //   this.listQuery.pageSize = data.limit
    //   this.handleFilterFile()()
    // },
  },
  mounted(){
      this.handleFilterCar()
  },
}
</script>

<style>
    .shadow{
        height: 750px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }
    .router-file{
        padding-top: 10px;
        padding-left: 10px;
    }
    .car-id{
        padding-bottom: 20px;
    }
</style>
